module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.2f1fd3e7.svg";